"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.VUESCROLL_OPTIONS = void 0;
/**
 * Configuration for the `<VueScroll>` component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.VUESCROLL_OPTIONS = {
    ops: {
        bar: { background: '#e51a1a' },
        scrollPanel: { scrollingX: false }
    }
};
//# sourceMappingURL=TextList.config.js.map